import type { App } from 'vue';
import type { ArcoOptions } from '../_utils/types';
import { setGlobalConfig, getComponentPrefix } from '../_utils/global-config';
import _ColorPicker from './colorPicker.vue';

const ColorPicker = Object.assign(_ColorPicker, {
  install: (app: App, options?: ArcoOptions) => {
    // eslint-disable-next-line no-console
    setGlobalConfig(app, options);

    const componentPrefix = getComponentPrefix(options);

    app.component(componentPrefix + _ColorPicker.name, _ColorPicker);
  },
});

export type CalendarInstance = InstanceType<typeof _ColorPicker>;
export type { ColorPickerProps } from './interface';

export default ColorPicker;
